module.exports = __webpack_public_path__ + "static/media/residential-mid-rise.6c0b703b.svg";